import React from 'react'
import { LuHeartOff } from "react-icons/lu"
import useAppContext from '../../hook/useAppContext'
import Empty from '../../components/empty/Empty'

const RelationCard = ({relation}) => {

      const {data, break_line} = useAppContext()

      if(relation.code) {
            return (
                  <div className="relation_card">
                        <Empty text={`Relation Not Found`} icon={<LuHeartOff />}/>
                  </div>
            )
      }

      const name = relation.name 
      const id = relation.id_xat 
      const avatar = relation.avatar 
      const me = relation.me 
      const about = relation.about.length === 0 ? data.relation.about : relation.about 
      const homepage = relation.homepage.length === 0 ? data.relation.homepage : relation.homepage 
      const love_count = relation.love_count === 'Undefined' ? "" : relation.love_count.time_lapse 

      return (
            <div className="relation_card">
                  <div className="relation_banner">
                        <div className="relation_banner__img flex">
                              <img src={avatar} alt={name} />
                        </div>
                        <div className="relation_banner__info flex">
                              <div className="relation_avatar flex">
                                    <img src={avatar} alt={name} />
                              </div>
                              <h3>{name}</h3>
                              <strong>{id}</strong>
                              <p>{love_count}</p>
                              <div className="relation_navigator flex">
                                    <a href={me} target="_blank" rel="noreferrer">xat.me</a>
                                    <a href={homepage} target="_blank" rel="noreferrer">site</a>
                              </div>
                        </div>
                  </div>
                  <div className="relation_about">
                        <p>{break_line(about)}</p>
                  </div>
            </div>
      )
}

export default RelationCard
